import * as React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import '../uglib_styles/collectionHighlight.css'
import Layout from '../uglib_components/layout'
import { get_labelled_field, get_optional_field} from 'src/uglib_utils/utils'


const CollectionHighlight = ( props ) => {
	const data = props.data.collections.nodes[0];
	
	const title = data.title;
	const ch_image = data.relationships.field_ch_image.localFile.childImageSharp.gatsbyImageData;

	const breadcrumbs = [
		{ 
			url: "",
			title: "Find",
		},
		{ 
			url: "/find/collections",
			title: "Our Collections",
		}
	]

	let attribution = <></>;
	if (data.field_attribution !== null) {
		attribution = <span className="attribution" dangerouslySetInnerHTML={{__html: data.field_attribution.processed}} />
	}

	const license = get_labelled_field(get_optional_field(data, 'relationships.field_content_license.description.processed'), <h2>License</h2>);

    return (
      <Layout breadcrumbs={breadcrumbs} title={title} bodyClass='collection-highlight'>
			{ attribution }

			{ /**** News story image ****/ }
			<GatsbyImage className="highlight-image" image={ch_image} alt={data.field_ch_image.alt} placeholder="blurred" />

			{ /**** Legacy body field ****/}
			<div dangerouslySetInnerHTML={{__html: data.body.processed}} />

			{ license }
      </Layout>
    )
}

export const query = graphql`
  	query ($id: String) {
		collections: allNodeCollectionHighlight(filter: {id: {eq: $id}}) {
			nodes {
				title
				path {
				  	alias
				}
				body {
					processed
				}
				id
				created
				changed
				field_attribution {
					processed
				}
				relationships {
					field_ch_image {
						localFile {
							childImageSharp {
								gatsbyImageData
							}
						}
					}
					field_content_license {
						description {
						  processed
						}
					}
				}
				field_ch_image {
					alt
					title
				}
			}
		}
		
  	}
`

export default CollectionHighlight